import styled from '@emotion/styled/macro'

import { btnMaxSizes, flexCenter } from 'style/emotion'

const CoursesOnlineBtnsContainer = styled('div')`
  margin-bottom: 24px;
  width: 100%;
`

const CoursesPhoneBtnContainer = styled('div')`
  ${flexCenter}

  margin-top: 24px;

  > .btn {
    ${btnMaxSizes}

    flex: 1;
  }
`

export { CoursesOnlineBtnsContainer, CoursesPhoneBtnContainer }
